<template>
  <page
    :custom-style="{
      height: '100vh',
      background: '#f5f5f5',
      display: 'flex',
      flexDirection: 'column'
    }"
  >
    <maple-nav-bar
      v-if="!isMiniProgram"
      class="nav-bar"
      left-arrow
      title="运费明细"
      right-text="运费规则"
      :safe-top-distance="statusBarHeight"
      @click-left="goBack"
      @click-right="goRules"
    />
    <div class="container">
      <topMsg
        :is-mini-program="isMiniProgram"
        :top-freight-msg="top_freight_msg"
        :selected_company_id="selected_company_id"
      ></topMsg>
      <div v-if="info && 'order_amount' in info" class="summary">
        <div class="content" :class="themeBgColorClass">
          <div class="content-head">
            <span>今日运费</span>
            {{ info.c_t }}
          </div>
          <div class="today-price">
            <span class="title">今日下单金额</span>
            <span class="unit">¥</span>
            <span class="value">
              {{ `${info.order_amount || '0'}` }}
            </span>
          </div>
          <div class="fee-detail">
            <div class="fee-detail-item">
              <p class="fee-detail-item-key">应付运费</p>
              <p class="fee-detail-item-value">
                {{ `¥${info.receive_total_amount || '0'}` }}
              </p>
            </div>
            <div class="fee-detail-item">
              <p class="fee-detail-item-key">已付运费</p>
              <p class="fee-detail-item-value">
                {{ `¥${info.receive_paid_amount || '0'}` }}
              </p>
            </div>
            <div class="fee-detail-item">
              <p class="fee-detail-item-key">已抵运费券</p>
              <p class="fee-detail-item-value">
                {{ `¥${info.freight_coupon_fee || '0'}` }}
              </p>
            </div>
            <div class="fee-detail-item">
              <p class="fee-detail-item-key">实付运费</p>
              <p class="fee-detail-item-value">
                {{ `¥${info.freight_pay_fee || '0'}` }}
              </p>
            </div>
          </div>
          <div
            v-if="info.back_amount_msg"
            class="fee-status"
            :class="themeLightBgColor"
          >
            {{ info.back_amount_msg }}
          </div>
        </div>
      </div>
      <div class="main-list">
        <p v-if="info.tips" class="tips">{{ info.tips }}</p>
        <ul class="detail-list">
          <div v-if="includedList.length" class="desc">
            计入累计下单金额
            <div :class="['include-sign', 'sign', themeLightBgColor]">
              计运费
            </div>
          </div>
          <li v-for="item in includedList" :key="item.raw_order_id">
            <div>
              <div class="detail-number">订单{{ item.raw_order_id || '' }}</div>
              <div class="detail-amount">¥{{ item.order_amount || 0 }}</div>
            </div>
            <div style="margin-top: 0.1rem">
              <div class="detail-date">
                {{ item.c_t }}
              </div>
              <div v-if="item.order_status_name" class="detail-status">
                {{ item.order_status_name }}
              </div>
            </div>
          </li>
        </ul>
        <ul class="detail-list">
          <div v-if="notIncludedList.length" class="desc">
            不计入累计下单金额
            <div :class="['notInclude-sign', 'sign']">不计运费</div>
          </div>
          <li v-for="item in notIncludedList" :key="item.raw_order_id">
            <div>
              <div class="detail-number">订单{{ item.raw_order_id || '' }}</div>
              <div class="detail-amount">¥{{ item.order_amount || 0 }}</div>
            </div>
            <div style="margin-top: 0.1rem">
              <div class="detail-date">
                {{ item.c_t }}
              </div>
              <div v-if="item.order_status_name" class="detail-status">
                {{ item.order_status_name }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <page-content v-if="error.show">
      <empty :text="error.msg" :sub-text="error.subMsg"></empty>
    </page-content>
  </page>
</template>

<script>
import { API } from '@/api'
import Empty from '@/common/layout/empty/index'
import Url from '@mc/mc-utils/js/url/url'
import { miniProgramEnv } from '@/defines/environment'
import { navBar } from '@/utils/native_interactions/native_bar'
import themeMixin from '@/common/mixins/theme'
import topMsg from './topMsg.vue'
export default {
  name: 'Detail',
  components: {
    Empty,
    topMsg
  },
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.isMiniProgram) {
        navBar.setTitle({
          text: '运费明细'
        })
      }
    })
  },
  data() {
    return {
      info: {},
      isMiniProgram: miniProgramEnv.isMiniProgram,
      backPressed: window.backPressed,
      includedList: [],
      notIncludedList: [],
      top_freight_msg: '',
      error: {
        show: false,
        msg: '未知错误。',
        subMsg: '未知错误。'
      },
      selected_company_id: ''
    }
  },
  created() {
    this.getFreightFeeDetail()
  },
  mounted() {
    if (window.history.length) {
      window.backPressed = function () {
        window.history.go(-1)
      }
    }
  },
  destroyed() {
    window.backPressed = this.backPressed
  },
  methods: {
    async getFreightFeeDetail() {
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
      const id = query.id || hashQuery.id || ''
      const freightDay = query.freight_day || hashQuery.freight_day || ''
      // eslint-disable-next-line camelcase
      const selected_company_id =
        query.selected_company_id || hashQuery.selected_company_id || ''
      // eslint-disable-next-line camelcase
      this.selected_company_id = selected_company_id
      this.$Loading()
      try {
        const data = await API.shippingFee.getFreightFeeDetail({
          order_id: id,
          freight_day: freightDay,
          selected_company_id
        })
        if (data.order_info.length) {
          this.info = data.order_info[0]
          this.top_freight_msg = data.top_freight_msg
          const includedList = []
          const notIncludedList = []
          data.order_info[0].items.forEach(item => {
            if (item.order_status_type) {
              includedList.push(item)
            } else {
              notIncludedList.push(item)
            }
          })
          this.includedList = includedList
          this.notIncludedList = notIncludedList
        }
      } catch (error) {
        this.$catch(error)
      }
      this.$Loading.hide()
    },
    goRules() {
      this.$router.push({
        name: 'shipping-fee-rules',
        query: {
          selected_company_id: this.selected_company_id
        }
      })
      this.$track(this.$trackMap.freight.freightDetailRules)
    },
    goBack() {
      this.$back()
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  transform: translate3d(0, 0, 0);

  background-color: #ffffff;
}

.page-content {
  bottom: 0;
}
.container {
  display: flex;

  position: relative;

  background-color: #f5f5f5;

  flex-direction: column;

  .main-list {
    padding: 0 0.24rem 0.24rem;

    flex: auto;
    overflow-y: auto;
    .tips {
      padding-bottom: 0.24rem;

      font-size: 0.24rem;
      color: #8c8c8c;
    }
    .detail-list {
      margin-bottom: 0.24rem;

      padding: 0 0.24rem;

      overflow: hidden;

      background-color: #fff;
      border-radius: 0.16rem;

      .desc {
        display: flex;

        position: relative;

        height: 0.9rem;

        border-bottom: 1px solid #f5f5f5;

        align-items: center;

        font-size: 0.3rem;
        font-weight: 600;

        .sign {
          display: flex;

          position: absolute;

          top: 0;
          right: -0.24rem;

          height: 0.56rem;

          padding: 0 0.24rem;

          border-bottom-left-radius: 0.16rem;

          align-items: center;

          font-weight: normal;
        }

        .include-sign {
          background-color: rgba(21, 187, 92, 0.15);

          color: #15bb5c;
        }

        .notInclude-sign {
          background-color: rgba(140, 140, 140, 0.15);

          color: #8c8c8c;
        }
      }

      li {
        margin-bottom: 0.16rem;
        padding: 0.24rem 0;

        font-size: 0.24rem;
        color: #262626;
        & > div {
          @include flex-row-between;
          .detail-number {
            font-size: 0.28rem;
          }
          .detail-amount {
            font-size: 0.32rem;
            font-weight: bold;
          }
          .detail-date {
            color: #8c8c8c;
          }
          .detail-status {
            color: #8c8c8c;
          }
        }
      }
    }
  }
  .summary {
    padding: 0.24rem 0.24rem 0.4rem;

    flex: none;
    .content {
      overflow: hidden;

      background-color: #15bb5c;
      border-radius: 0.16rem;

      flex: auto;

      &-head {
        height: 0.8rem;
        padding: 0.24rem 0.24rem 0.16rem;

        font-size: 0.28rem;
        color: #fff;
      }

      .fee-detail {
        padding: 0.12rem 0 0.2rem;
        @include flex-row-between;

        &-item {
          flex: 1;

          text-align: center;

          &-key {
            font-size: 0.24rem;
            color: rgba(255, 255, 255, 0.8);
          }
          &-value {
            margin-top: 0.06rem;

            font-size: 0.3rem;
            color: #fff;
          }
        }
      }

      .fee-status {
        padding: 0.16rem 0.24rem;

        background-color: #dcf5e7;

        font-size: 0.24rem;
        color: #15bb5c;
      }
    }

    ul {
      display: flex;

      margin-top: 6px;

      flex: row nowrap;
      justify-content: center;
      align-items: center;
    }
  }
}

.today-price {
  display: flex;

  height: 0.6rem;

  padding-left: 0.24rem;

  align-items: baseline;

  color: #fff;
  .title {
    margin-right: 0.1rem;

    font-size: 0.24rem;
  }
  .unit {
    font-size: 0.24rem;
  }
  .value {
    font-size: 0.32rem;
  }
}
</style>
